import { render, staticRenderFns } from "./TableData.vue?vue&type=template&id=bb34fb12&"
import script from "./TableData.vue?vue&type=script&lang=js&"
export * from "./TableData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports